import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import checkedIcon from '../../../../public/assets/img/checked.svg';
import unCheckedIcon from '../../../../public/assets/img/unchecked.svg';
import sevenNowLogo from '../../../../public/assets/img/seven-now-logo.svg';
import { TextField, CardContent, Card, styled, InputAdornment, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CANCEL, RESET_PASSWORD, RESET_PASSWORD_SUB_TEXT, MERCHANT_PORTAL_TEXT } from '../../../constants/buttonConstants';
import { PASSWORD_CHAR, PASSWORD_MIN, PASSWORD_REP, PLEASE_WAIT, RESEND_TEXT, PASSWORD_NUMBER_REQ } from '../../../constants/settingsPageConstants';
import { LOGIN_VERBIAGE, EMAIL_VERBIAGE, LOGIN_SUB_TEXT } from '../../../constants/landingConstant';
import { confirmForgotPasswordRequest, confirmForgotPasswordReset, forgetPasswordEmailRequest } from '../../../redux/actions/loginServiceAction';
import './changepassword.scss';
import { confirmForgotPasswordResponseSaga, usernameSaga } from '../../../redux/saga/loginServiceSelector';
import { checkForRepeatedSequence, onlySpecialCharaAllowed, restrictOnlyFewSpecialChara, validateOTP, containsAtleastOneNumber } from '../../../shared/utils/format.helpers';
import { encryptPassword } from '../../../shared/utils/common';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#111111',
    fontWeight: '700',
  },
});

function ChangePassword() {

	const navigator = useNavigate();
	const confirmForgotPasswordResponse = useSelector(confirmForgotPasswordResponseSaga);
	let userNameString = useSelector(usernameSaga);
	const [tokenError, setTokenError] = useState(false);
	const [confirmpasswordError, setconfirmpasswordError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [formValid, setformValid] = useState(false);
	const [formData, setformData] = useState({
		fields: {
		token: '',
		password: '',
		confirmpassword: '',
		},
		errors: {},
	});
	const [confirmpasswordErrorIcon, setconfirmpasswordErrorIcon] = useState(null);
	const [tokenErrorIcon, setTokenErrorIcon] = useState(null);
	const [passwordErrorIcon, setpasswordErrorIcon] = useState(false);
	const [miniCharaCheckIcon, setminiCharCheckIcon] = useState(unCheckedIcon);
	const [specialCharaCheckIcon, setspecialCharaCheckIcon] = useState(unCheckedIcon);
	const [noRepCharaCheckIcon, setNoRepCharaCheckIcon] = useState(unCheckedIcon);
	const [containsNumberCheckIcon, setContainsNumberCheckIcon] = useState(unCheckedIcon);
	const [apiInProgress, setapiInProgress] = useState(false);
	const [emailWord, setEmailWord] = useState('');
	const dispatch = useDispatch();
	var timer = 0;
	let secondsValue;
	const [seconds, setSeconds] = useState(60);
	const [showSeconds, setShowSeconds] = useState(false);

	useEffect(() => {
		let emailWordText = EMAIL_VERBIAGE;
		emailWordText = emailWordText.replace('[email]', process.env.REQUEST_ACCESS_MAIL);
		setEmailWord(emailWordText);
	}, []);

	useEffect(() => {
		if (confirmForgotPasswordResponse) {
			if (confirmForgotPasswordResponse?.msg) {
				setapiInProgress(false);
				dispatch(confirmForgotPasswordReset());
				navigator('/forget_password_failed');
			} else {
				setapiInProgress(false);
				dispatch(confirmForgotPasswordReset());
				navigator('/update_password_success');
			}
		}
	}, [confirmForgotPasswordResponse]);

	const confirmPasswordReset = (e) => {
		e.preventDefault();
		if(formValid){
			setapiInProgress(true);
			const updatedPassword = encryptPassword(formData.fields.password);
			// console.log('dfsdf ',userNameString, formData.fields.token, formData.fields.password)
			dispatch(
				confirmForgotPasswordRequest(
				userNameString,
				updatedPassword,
				formData.fields.token
				)
			);
		}
	};

	const cancelUserCreationHandler = () => {
		navigator('/');
	};

	const handleChange = (e) => {
		let fields = formData.fields;
		let errors = formData.errors;
		fields[e.target.id] = e.target.value;
		
		if (e.target.id === 'token') {
		if (formData.fields.token === '' || !validateOTP(formData.fields.token)) {
			setTokenError(true);
			setTokenErrorIcon(WarningTriangle);
			errors[e.target.id] = 'Enter OTP provided';
		} else {
			setTokenError(false);
			delete errors[e.target.id];
		}
		}
		// console.log('fsdf ',e.target.id)
		if (e.target.id === 'password') {
			if (
				formData.fields.password === '' ||
				formData.fields.password.length < 14 ||
				formData.fields.password.length > 20 ||
				!restrictOnlyFewSpecialChara(formData.fields.password)
			) {
				setPasswordError(true);
				setpasswordErrorIcon(WarningTriangle);
				setminiCharCheckIcon(unCheckedIcon);

				onlySpecialCharaAllowed(formData.fields.password) === true
				? setspecialCharaCheckIcon(checkedIcon)
				: setspecialCharaCheckIcon(unCheckedIcon);

				containsAtleastOneNumber(formData.fields.password) === true
				? setContainsNumberCheckIcon(checkedIcon)
				: setContainsNumberCheckIcon(unCheckedIcon);

				checkForRepeatedSequence(formData.fields.password) 
				? setNoRepCharaCheckIcon(checkedIcon)
				: setNoRepCharaCheckIcon(unCheckedIcon);

				errors[e.target.id] = 'Enter a password';
			} else {
				onlySpecialCharaAllowed(formData.fields.password) === true
				? setspecialCharaCheckIcon(checkedIcon)
				: setspecialCharaCheckIcon(unCheckedIcon);

				containsAtleastOneNumber(formData.fields.password) === true
				? setContainsNumberCheckIcon(checkedIcon)
				: setContainsNumberCheckIcon(unCheckedIcon);

				checkForRepeatedSequence(formData.fields.password) 
				? setNoRepCharaCheckIcon(checkedIcon)
				: setNoRepCharaCheckIcon(unCheckedIcon);

				formData.fields.password.length >= 14 &&
				formData.fields.password.length <= 20
				? setminiCharCheckIcon(checkedIcon)
				: setminiCharCheckIcon(unCheckedIcon);

				if ( restrictOnlyFewSpecialChara(formData.fields.password) && formData.fields.password.length >= 14 ) {
					setPasswordError(false);
					setpasswordErrorIcon(null);
					delete errors[e.target.id];
				}
				if (formData.fields.password === formData.fields.confirmpassword) {
					setconfirmpasswordError(false);
					setconfirmpasswordErrorIcon(null);
					delete errors['confirmpassword'];
				} else {
					if (formData.fields.confirmpassword.length >= 14) {
						setconfirmpasswordErrorIcon(WarningTriangle);
						setconfirmpasswordError(true);
						errors['confirmpassword'] = 'Password do not match';
					}
				}
			}
		}

		if (e.target.id === 'confirmpassword') {
			if ( formData.fields.confirmpassword === '' || formData.fields.confirmpassword.length < 14 ) {
				setconfirmpasswordErrorIcon(WarningTriangle);
				setconfirmpasswordError(true);
				errors['confirmpassword'] = 'Enter confirm password';
			} else {
				if (formData.fields.password === formData.fields.confirmpassword) {
					setconfirmpasswordError(false);
					setconfirmpasswordErrorIcon(null);
					delete errors['confirmpassword'];
				} else {
					if (formData.fields.confirmpassword.length >= 14) {
						setconfirmpasswordErrorIcon(WarningTriangle);
						setconfirmpasswordError(true);
						errors['confirmpassword'] = 'Password do not match';
					}
				}
			}
		}
		setformData({ ...formData });
	};

	useEffect(() => {
		setformValid(
			formData.fields.token.length > 0 &&
			formData.fields.password.length > 0 &&
			formData.fields.confirmpassword.length > 0 &&
			formData.fields.password === formData.fields.confirmpassword &&
			!tokenError &&
			!passwordError &&
			!confirmpasswordError &&
			checkForRepeatedSequence(formData.fields.password) &&
			restrictOnlyFewSpecialChara(formData.fields.password) &&
			onlySpecialCharaAllowed(formData.fields.password) &&
			containsAtleastOneNumber(formData.fields.password)
		);
		// console.log('ERRORs ',tokenError, passwordError, confirmpasswordError)
	}, [formData.fields, tokenError, passwordError, confirmpasswordError]);

	const userAccountList = (landingStyle) => {
		return (
		<div className={landingStyle ? 'content-leftPanel' : ''}>
			{landingStyle ? (
			<>
				<p>{LOGIN_VERBIAGE}</p>
			</>
			) : (
			''
			)}
			<p>{LOGIN_SUB_TEXT}</p>
		</div>
		);
	};

	const handleEmailResend = (e) => {
		e.preventDefault();
		startTimer();
		dispatch(forgetPasswordEmailRequest(userNameString));
	};

	const startTimer = () => {
		if (timer === 0 && seconds === 60) {
			setShowSeconds(true);
			secondsValue = seconds;
			timer = setInterval(countDown, 1000);
		}
	};

	const countDown = () => {
		if (secondsValue > 0) {
			secondsValue = secondsValue - 1;
			setSeconds(secondsValue);
		} else {
			clearInterval(timer);
		}
	};

	useEffect(() => {
		// Check if we're at zero.
		if (seconds === 0) {
			setShowSeconds(false);
			clearInterval(timer);
			setSeconds(60);
		}
	}, [seconds]);

	return (
		<>
		<Container
			fluid
			className='vh-100 d-flex flex-column '
			data-testid='test-password'
		>
			<Row className='h-100'>
			<Col className='background-white-class'>
				<Row className='margin_Panel'></Row>
				<Row>
				<Col xs={14}>
					<div className='landing-logo-holder aligncenter'>
					<img src={sevenNowLogo} className='img-right-align' alt='SevenNow header Logo' />
					<h2 className='merchant-title1'> {MERCHANT_PORTAL_TEXT}</h2>
					</div>
					{userAccountList(true)}
				</Col>
				</Row>
			</Col>
			<Col>
				<div className='margin_Panel'></div>
				<div className='forget-cont'>
				<Col className='cont-class'>
					<Card variant='outlined' className='cont-min-class'>
					<p className='reset-title'>{RESET_PASSWORD}</p>
					<p className='reset-sub-text'>{RESET_PASSWORD_SUB_TEXT}</p>
					<CardContent>
						<form
						className='form-container'
						autoComplete='off'
						onSubmit={confirmPasswordReset}
						>
						<CssTextField
							id='token'
							label='OTP'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='text'
							sx={{ mb: 3 }}
							aria-label='OTP'
							fullWidth
							error={tokenError}
							helperText={formData.errors?.token}
							inputProps={{ maxLength: 6 }}
							InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
								{formData.errors?.token ? (
									<img
										src={tokenErrorIcon}
										className='error-icon'
										data-testid='tokenerrorIcon'
									/>
								) : null}
								</InputAdornment>
							),
							}}
						/>
						<CssTextField
							id='password'
							label='Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Password'
							error={passwordError}
							helperText={formData.errors?.password}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
								{formData.errors?.password ? (
									<img
										src={passwordErrorIcon}
										className='error-icon'
										data-testid='passworderrorIcon'
									/>
								) : null}
								</InputAdornment>
							),
							}}
						/>
						<CssTextField
							id='confirmpassword'
							label='Confirm Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Confirm Password'
							error={confirmpasswordError}
							helperText={formData.errors?.confirmpassword}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
								{formData.errors?.confirmpassword ? (
									<img
										src={confirmpasswordErrorIcon}
										className='error-icon'
										data-testid='confirmpassworderrorIcon'
									/>
								) : null}
								</InputAdornment>
							),
							}}
						/>
						<div className='resend-cont'>
							<button
							className='resend-item'
							disabled={showSeconds}
							onClick={(e) => handleEmailResend(e)}
							>
							{RESEND_TEXT}
							</button>
							{showSeconds ? (
							<p className='resend-timer-msg'>
								{PLEASE_WAIT} {seconds}
							</p>
							) : null}
						</div>

						<button
							className='form-container--primaryButton'
							aria-label='Submit Reset Password'
							disabled={!formValid}
							variant='outlined'
							type='submit'
							data-testid='resetPasswordButton'
						>
							{RESET_PASSWORD}
						</button>
						</form>
						<button
						className='form-container--secondaryButton'
						aria-label='Cancel Reset Password'
						variant='outlined'
						onClick={cancelUserCreationHandler}
						type='button'
						>
						{CANCEL}
						</button>
						<br />
					</CardContent>
					<div className='check-container'>
						<div className='check-item'>
							<img className='check-img' src={miniCharaCheckIcon} />
							<p className='check-text'>{PASSWORD_MIN}</p>
						</div>
						<div className='check-item'>
							<img className='check-img' src={specialCharaCheckIcon} />
							<p className='check-text'>{PASSWORD_CHAR}</p>
						</div>
						<div className='check-item'>
							<img className='check-img' src={containsNumberCheckIcon} />
							<p className='check-text'>{PASSWORD_NUMBER_REQ}</p>
						</div>
						<div className='check-item'>
							<img className='check-img' src={noRepCharaCheckIcon} />
							<p className='check-text'>{PASSWORD_REP}</p>
						</div>
					</div>
					</Card>
				</Col>
				<Col xs={2}></Col>
				</div>
			</Col>
			</Row>
		</Container>

		{apiInProgress === true ? (
			<div className='loader-style'>
			<CircularProgress />
			</div>
		) : null}
		</>
	);
}
export default ChangePassword;
